<script>
import Translatable from '@src/mixins/translatable.js'
import { mapGetters } from 'vuex'

export default {
  mixins: [
    Translatable
  ],
  props: {
    step: {
      type: Object,
      required: true
    },
    orderingNum: {
      type: Number,
      required: true
    }
  },
  computed: {
    ...mapGetters('plan', [
      'appLinks',
    ]),
  },
}
</script>

<template>
  <div class="card">
    <div>
      <h4 class="step-title" v-html="step.title">
      </h4>
      <div class="step-caption" v-html="step.description">
      </div>
    </div>
    <div :class="orderingNum === 1 ? 'content-first' : 'content'">
      <div v-if="orderingNum === 1" class="app-container">
        <!-- temporarily -->
        <!-- <a :href="appLinks && appLinks[1]" target="_blank"> -->
        <a href="https://apps.apple.com/us/app/prague-cool-pass/id1378275600" target="_blank">
          <div class="appstore"></div>
        </a>
        <!-- temporarily -->
        <!-- <a :href="appLinks && appLinks[0]" target="_blank"> -->
        <a href="https://play.google.com/store/apps/details?id=com.bookletia.coolpassprague" target="_blank">
          <div class="googleplay"></div>
        </a>
      </div>
      <div class="ordering">
        {{ orderingNum }}
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';

.card {
  height: 180px;
  width: 235px;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  background-color: $dark-blue;
  border-radius: 10px;
  padding: 20px 15px 27px 20px;
}

.step-title {
  font-family: Open Sans Bold, sans-serif;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 23px;
  color: $white;
  text-transform: uppercase;
  margin-bottom: 6px;
}

.step-caption {
  font-family: Open Sans, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 23px;
  color: $white;
}

.content, .content-first {
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
}

.app-container {
  justify-self: start;
  margin-right: 50px;
}

.app-mixin {
  width: 151px;
  height: 45px;
  background-repeat: no-repeat;
  background-position: center;
  margin-top: 9px
}

.appstore {
  @extend .app-mixin ;
  background-image: url("../../assets/images/appstore.svg");
}

.googleplay {
  @extend .app-mixin ;
  background-image: url("../../assets/images/googleplay.svg");
}

.ordering {
  font-family: Arial, sans-serif;
  font-weight: bold;
  font-size: 48px;
  line-height: 62px;
  width: 30px;
  height: 35px;
  color: $hover-orange;
}

$scale: 0.93;
$gap: 20;

@media only screen and (min-width: $mobile-screen-width) and (max-width: $container-width-xs) {
  .card {
    height: 230px;
    width: 90%;
  }

  .app-container {
    margin-right: 50px;
  }

  .content-first {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
  }
}
</style>
